export default __webpack_public_path__ + "static/media/ui_package_code_indicator_02.3590e9d7.png";